import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  block: {
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: '100%',
    },
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1000,
    top: 37,
    right: 0,
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      width: '95vw',
      maxWidth: '350px',
      left: '-16px',
      right: 'auto',
      top: '50px',
      padding: theme.spacing(1.5),
    },
  },
  iconBtn: {
    padding: theme.spacing(0, 1),
    marginRight: theme.spacing(1),
    minWidth: '40px',
    minHeight: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      minWidth: '44px',
      minHeight: '44px',
      marginRight: theme.spacing(0.5),
    },
  },
  inputWide: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: 50,
    borderRadius: 4,
    backgroundColor: '#fff',
    padding: theme.spacing(0, 2),
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      height: 46,
      fontSize: '14px',
      padding: theme.spacing(0, 1.5),
    },
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
}));
